export function camelCase(text: string): string {
  text = text.replace(/[-_\s.]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''));
  return text.substring(0, 1).toLowerCase() + text.substring(1);
}

export function generateAlphabet(): string[] {
  return new Array(26).fill(1).map((_, i) => String.fromCharCode(65 + i));
}
